import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GridFilterService {
  public readonly filters = signal<Record<string, any>>({});
}
